import React from "react";
import styled from "styled-components";
import Emoji from "./Emoji";
var StyledCard = styled.div.withConfig({
  displayName: "Card__StyledCard",
  componentId: "sc-1x2vwsh-0"
})(["display:flex;flex-direction:column;justify-content:space-between;background:", ";border-radius:2px;border:1px solid ", ";padding:1.5rem;"], function (props) {
  return props.theme.colors.ednBackground;
}, function (props) {
  return props.theme.colors.lightBorder;
});
var Description = styled.p.withConfig({
  displayName: "Card__Description",
  componentId: "sc-1x2vwsh-1"
})(["opacity:0.8;"]);
var TopContent = styled.div.withConfig({
  displayName: "Card__TopContent",
  componentId: "sc-1x2vwsh-2"
})([""]);

var Card = function Card(_ref) {
  var emoji = _ref.emoji,
      title = _ref.title,
      description = _ref.description,
      children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(StyledCard, {
    className: className
  }, /*#__PURE__*/React.createElement(TopContent, null, emoji && /*#__PURE__*/React.createElement(Emoji, {
    size: 3,
    text: emoji
  }), /*#__PURE__*/React.createElement("h3", null, title), /*#__PURE__*/React.createElement(Description, null, description)), children);
};

export default Card;